module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/feature-nationwide-979532c3f8e019095c5ae7eccd17df68.png";